import { createTheme } from "@mui/material/styles";

// const theme = createTheme({
//   // General
//   typography: {
//     fontFamily: "Lexend, sans- serif",
//   },

//   palette: {
//     primary: {
//       main: "#1976d2", // blue
//     },
//     secondary: {
//       main: "#f50057", // pink
//     },

//     success: {
//       main: "#24A600", // green
//     },
//     danger: {
//       main: "#f44336", // red
//     },
//     neutral: {
//       main: "#64748B", // gray-blue
//       contrastText: "#fff",
//     },
//     background: {
//       paper: "#ffff",
//       default: "#f4f6f8",
//       // default: "#f4f6f8",
//     },
//   },

//   //Status Colors
//   status: {
//     in_progress: "#C39C00",
//     rejected: "#FF470A",
//     open: "#0ABAB5",
//     closed: "#1DC400",
//     resolved: "#24A600",
//   },

//   //Background Colors
//   bgCol: {
//     default: "#ffff",
//     paper: "#ECECEC",
//     sidebarBg: "#ffff",
//     sidebarInfoBg:
//       "linear-gradient(180deg,rgba(10, 186, 181, 1) 0%, rgba(5, 84, 82, 1) 100%)",
//     footerBg: "#ffff",
//     menuHover: "#e0f7fa",
//     loginOtpBg:
//       "linear-gradient(180deg,rgba(5, 131, 127, 1) 0%, rgba(98, 211, 208, 1) 50%, rgba(192, 242, 240, 1) 100%)",
//     headerBg: "#0ABAB5",
//     recietBg: "#EFEFEF",
//     ticketBg: "#FFFDF8",
//   },

//   //Text Colors
//   textCol: {
//     primaryHeading: "#008D89",
//     subHeading: "#747474",
//     desc: "#595959",
//     loginSubText: "#057A76",
//     placeholder: "#7C7C7C",
//     inactive: "#bfbfbf",
//   },

//   //Borders Colors
//   borders: {
//     primaryBorder: "#92DAD8",
//     secondaryBorder: "#666262",
//   },

//   //Buttons Colors
//   button: {
//     primaryBtn: "#0ABAB5",
//     secondaryBtn: "#B6EFED",
//   },

//   // Timeline Status Colors
//   timelineStatuses: {
//     open: " linear-gradient(180deg,rgba(0, 179, 134, 1) 0%, rgba(29, 216, 169, 1) 50%, rgba(72, 255, 209, 1) 100%)",
//     assigned:
//       " linear-gradient(180deg,rgba(53, 143, 227, 1) 0%, rgba(86, 165, 238, 1) 50%, rgba(161, 210, 255, 1) 100%)",
//     in_progress:
//       "linear-gradient(180deg,rgba(180, 150, 0, 1) 0%,rgba(200, 160, 0, 1) 50%,rgba(220, 180, 20, 1) 100%)",
//     resolved:
//       "linear-gradient(180deg,rgba(5, 146, 0, 1) 0%, rgba(28, 194, 22, 1) 50%, rgba(60, 223, 54, 1) 100%)",

//     rejected:
//       " linear-gradient(180deg,rgba(228, 0, 0, 1) 0%, rgba(255, 37, 37, 1) 50%, rgba(255, 84, 84, 1) 100%)",
//   },

//   // Service Priority
//   priorities: {
//     low: "#07fc03",
//     medium: "#fcd303",
//     high: "#fc2003",
//   },

//   lightTheme: {
//     // Entire Theme
//     themeCol: "#008080",
//     notificationDot: "rgba(255, 42, 45, 1)",
//     loadingLogoGradient:
//       "linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgba(30, 139, 144, 1) 100%)",
//     textFieldBorder: "rgba(217, 217, 217, 1)",
//     placeholder: "rgba(178, 178, 178, 1)",
//     headerTextCol: "rgba(3, 91, 91, 1)",

//     header: {
//       home: "linear-gradient(90deg,rgba(0, 173, 173, 1) 0%, rgba(68, 40, 160, 1) 100%)",
//       performance:
//         "linear-gradient(180deg,rgba(0, 78, 87, 1) 0%, #008080 100%)",
//     },
//     // Priority Indicating Circles
//     prioritieIndicators: {
//       low: "#0E830A",
//       medium: "#FFAC00",
//       high: "#FF474A",
//     },

//     // Priority Texts
//     priorities: {
//       high: {
//         bgCol: "rgba(253, 134, 136, 1)",
//         borderCol: "rgba(255, 71, 74, 1)",
//         textCol: "#FF474A",
//       },
//       medium: {
//         bgCol: "rgba(255, 244, 231, 1)",
//         borderCol: "rgba(255, 154, 71, 1)",
//         textCol: "#FFAC00 ",
//       },
//       low: {
//         bgCol: "rgba(228, 255, 227, 1)",
//         borderCol: "rgba(14, 131, 10, 1)",
//         textCol: "#0E830A",
//       },
//     },

//     // Status
//     statuses: {
//       in_progress: {
//         bgCol: "#FFFCEB",
//         borderCol: "#F7B733",
//         textCol: "#F7B733",
//       },
//       resolved: {
//         bgCol: "#E6F9EE",
//         borderCol: "#0E830A",
//         textCol: "#0E830A",
//       },
//       follow_up: {
//         bgCol: "#E4F0FF",
//         borderCol: "#1565C0",
//         textCol: "#1565C0",
//       },
//       recurring: {
//         bgCol: "#F3E8FD",
//         borderCol: "#7B1FA2",
//         textCol: "#7B1FA2",
//       },
//       rejected: {
//         bgCol: "#FFEBEB",
//         borderCol: "#C62828",
//         textCol: "#FF474A",
//       },
//     },

//     // Reports Progress Bars
//     performanceProgressBars: {
//       excellent: "rgba(255, 193, 7, 1)", // Darker Tone
//       // excellent: "rgba(255, 215, 0, 1)", // Lighter Tone
//       good: "rgba(72, 177, 69, 1)",
//       average: "rgba(255, 198, 107, 1)",
//       poor: "rgba(255, 147, 149, 1)",
//     },

//     // Ticket Card
//     ticketCard: {
//       heading: {
//         primary: "rgba(26, 26, 26, 1)",
//         secondary: "rgba(26, 26, 26, 0.75)",
//         tertiary: "rgba(26, 26, 26, 0.5)",
//       },
//       date: "rgba(103, 103, 103, 1)",
//     },

//     // Resolved Tickets Section
//     resolved: {
//       dayPicker: {
//         textCol: "rgba(72, 72, 72, 1)",
//         bgCol: "rgba(222, 222, 222, 1)",
//       },
//     },
//   },

//   darkTheme: {
//     // Entire Theme
//     themeCol: "#008080",
//     notificationDot: "rgba(255, 42, 45, 1)",
//     loadingLogoGradient:
//       "linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgba(30, 139, 144, 1) 100%)",
//     textFieldBorder: "rgba(217, 217, 217, 1)",
//     placeholder: "rgba(178, 178, 178, 1)",

//     // Priority Indicating Circles
//     prioritieIndicators: {
//       high: "rgba(253, 134, 136, 1)",
//       medium: "rgba(255, 154, 71, 1)",
//       low: "rgba(14, 131, 10, 1)",
//     },

//     // Priority Texts
//     prioritieTexts: {
//       high: {
//         textCol: "rgba(255, 71, 74, 1)",
//         bgCol: "rgba(253, 134, 136, 1)",
//       },
//       medium: {
//         textCol: "rgba(255, 154, 71, 1)",
//         bgCol: "rgba(255, 244, 231, 1)",
//       },
//       low: {
//         textCol: "rgba(14, 131, 10, 1)",
//         bgCol: "rgba(228, 255, 227, 1)",
//       },
//     },

//     // Status
//     statuses: {
//       open: {
//         textCol: "rgba(14, 131, 10, 1)",
//         bgCol: "rgba(227, 255, 226, 1)",
//       },
//       pending: {
//         textCol: "rgba(255, 71, 74, 1)",
//         bgCol: "rgba(253, 134, 136, 1)",
//       },
//       followUp: {
//         textCol: "rgba(255, 71, 74, 1)",
//         bgCol: "rgba(253, 134, 136, 1)",
//       },
//       resolved: {
//         textCol: "rgba(255, 71, 74, 1)",
//         bgCol: "rgba(253, 134, 136, 1)",
//       },
//       rejected: {
//         textCol: "rgba(255, 71, 74, 1)",
//         bgCol: "rgba(255, 240, 240, 1)",
//       },
//     },

//     // Reports Progress Bars
//     performanceProgressBars: {
//       // excellent: "rgba(255, 193, 7, 1)", // Darker Tone
//       excellent: "rgba(255, 215, 0, 1)", // Lighter Tone
//       good: "rgba(72, 177, 69, 1)",
//       average: "rgba(255, 198, 107, 1)",
//       poor: "rgba(255, 147, 149, 1)",
//     },

//     // Ticket Card
//     ticketCard: {
//       heading: {
//         primary: "rgba(26, 26, 26, 1)",
//         secondary: "rgba(26, 26, 26, 0.75)",
//         tertiary: "rgba(26, 26, 26, 0.5)",
//       },
//       date: "rgba(103, 103, 103, 1)",
//     },

//     // Resolved Tickets Section
//     resolved: {
//       dayPicker: {
//         textCol: "rgba(72, 72, 72, 1)",
//         bgCol: "rgba(222, 222, 222, 1)",
//       },
//     },
//   },

//   gradientCollection: [
//     "linear-gradient(180deg,#008080 0%, rgba(116, 214, 214, 1) 100%)",
//     "linear-gradient(180deg,rgba(251, 144, 255, 1) 0%, rgba(157, 57, 124, 1) 100%)",
//     "linear-gradient(180deg,rgba(247, 183, 51, 1) 0%, rgba(240, 216, 167, 1) 100%)",
//     "linear-gradient(180deg,rgba(247, 183, 51, 1) 0%, rgba(255, 71, 74, 1) 100%)",
//     "linear-gradient(180deg,rgba(68, 40, 160, 1) 0%, rgba(255, 255, 255, 1) 100%)",
//   ],
// });

const theme = createTheme({
  typography: {
    fontFamily: "Lexend, sans-serif",
  },

  palette: {
    primary: {
      main: "#102A83", // royal blue
    },

    secondary: {
      main: "#E11D48", // ruby red
    },

    success: {
      main: "#15803D",
    },

    danger: {
      main: "#DC2626",
    },

    neutral: {
      main: "#64748B",
      contrastText: "#fff",
    },

    background: {
      paper: "#FFFFFF",
      default: "#F8F7F3",
    },
  },

  status: {
    in_progress: "#C28A00",
    rejected: "#DC2626",
    open: "#102A83",
    closed: "#15803D",
    resolved: "#15803D",
  },

  bgCol: {
    default: "#FFFFFF",
    paper: "#F4F4F5",
    sidebarBg: "#FFFFFF",

    sidebarInfoBg: "linear-gradient(180deg, #102A83 0%, #1D4ED8 100%)",

    footerBg: "#FFFFFF",

    menuHover: "#EEF2FF",

    loginOtpBg:
      "linear-gradient(180deg, #102A83 0%, #1E3A8A 50%, #DBEAFE 100%)",

    headerBg: "#102A83",

    recietBg: "#F5F5F5",

    ticketBg: "#FFFCF5",
  },

  textCol: {
    primaryHeading: "#102A83",
    subHeading: "#6B7280",
    desc: "#4B5563",
    loginSubText: "#1E3A8A",
    placeholder: "#9CA3AF",
    inactive: "#D1D5DB",
  },

  borders: {
    primaryBorder: "#CBD5E1",
    secondaryBorder: "#94A3B8",
  },

  button: {
    primaryBtn: "#102A83",
    secondaryBtn: "#E0E7FF",
  },

  timelineStatuses: {
    open: "linear-gradient(180deg, #102A83 0%, #2563EB 100%)",

    assigned: "linear-gradient(180deg, #1D4ED8 0%, #60A5FA 100%)",

    in_progress: "linear-gradient(180deg, #A16207 0%, #D4A017 100%)",

    resolved: "linear-gradient(180deg, #166534 0%, #22C55E 100%)",

    rejected: "linear-gradient(180deg, #B91C1C 0%, #EF4444 100%)",
  },

  priorities: {
    low: "#22C55E",
    medium: "#F59E0B",
    high: "#EF4444",
  },

  lightTheme: {
    themeCol: "#102A83",

    notificationDot: "#EF4444",

    loadingLogoGradient: "linear-gradient(180deg, #FFFFFF 0%, #102A83 100%)",

    textFieldBorder: "#D1D5DB",

    placeholder: "#9CA3AF",

    headerTextCol: "#0F172A",

    header: {
      home: "linear-gradient(90deg, #102A83 0%, #1D4ED8 100%)",

      performance: "linear-gradient(180deg, #0F172A 0%, #102A83 100%)",
    },

    prioritieIndicators: {
      low: "#15803D",
      medium: "#D97706",
      high: "#DC2626",
    },

    priorities: {
      high: {
        bgCol: "#FEE2E2",
        borderCol: "#DC2626",
        textCol: "#DC2626",
      },

      medium: {
        bgCol: "#FEF3C7",
        borderCol: "#D97706",
        textCol: "#D97706",
      },

      low: {
        bgCol: "#DCFCE7",
        borderCol: "#15803D",
        textCol: "#15803D",
      },
    },

    statuses: {
      in_progress: {
        bgCol: "#FFF7ED",
        borderCol: "#D97706",
        textCol: "#D97706",
      },

      resolved: {
        bgCol: "#DCFCE7",
        borderCol: "#15803D",
        textCol: "#15803D",
      },

      follow_up: {
        bgCol: "#DBEAFE",
        borderCol: "#2563EB",
        textCol: "#2563EB",
      },

      recurring: {
        bgCol: "#F3E8FF",
        borderCol: "#9333EA",
        textCol: "#9333EA",
      },

      rejected: {
        bgCol: "#FEE2E2",
        borderCol: "#DC2626",
        textCol: "#DC2626",
      },
    },

    performanceProgressBars: {
      excellent: "#D4A017",
      good: "#22C55E",
      average: "#FBBF24",
      poor: "#F87171",
    },

    ticketCard: {
      heading: {
        primary: "#111827",
        secondary: "rgba(17, 24, 39, 0.75)",
        tertiary: "rgba(17, 24, 39, 0.5)",
      },

      date: "#6B7280",
    },

    resolved: {
      dayPicker: {
        textCol: "#374151",
        bgCol: "#E5E7EB",
      },
    },
  },

  darkTheme: {
    themeCol: "#102A83",

    notificationDot: "#EF4444",

    loadingLogoGradient: "linear-gradient(180deg, #FFFFFF 0%, #102A83 100%)",

    textFieldBorder: "#374151",

    placeholder: "#9CA3AF",

    prioritieIndicators: {
      high: "#EF4444",
      medium: "#F59E0B",
      low: "#22C55E",
    },

    prioritieTexts: {
      high: {
        textCol: "#EF4444",
        bgCol: "#7F1D1D",
      },

      medium: {
        textCol: "#F59E0B",
        bgCol: "#78350F",
      },

      low: {
        textCol: "#22C55E",
        bgCol: "#14532D",
      },
    },

    statuses: {
      open: {
        textCol: "#22C55E",
        bgCol: "#14532D",
      },

      pending: {
        textCol: "#EF4444",
        bgCol: "#7F1D1D",
      },

      followUp: {
        textCol: "#3B82F6",
        bgCol: "#1E3A8A",
      },

      resolved: {
        textCol: "#22C55E",
        bgCol: "#14532D",
      },

      rejected: {
        textCol: "#EF4444",
        bgCol: "#7F1D1D",
      },
    },

    performanceProgressBars: {
      excellent: "#D4A017",
      good: "#22C55E",
      average: "#FBBF24",
      poor: "#F87171",
    },

    ticketCard: {
      heading: {
        primary: "#F9FAFB",
        secondary: "rgba(249,250,251,0.75)",
        tertiary: "rgba(249,250,251,0.5)",
      },

      date: "#9CA3AF",
    },

    resolved: {
      dayPicker: {
        textCol: "#E5E7EB",
        bgCol: "#374151",
      },
    },
  },

  gradientCollection: [
    "linear-gradient(180deg, #102A83 0%, #3B82F6 100%)",

    "linear-gradient(180deg, #E11D48 0%, #FB7185 100%)",

    "linear-gradient(180deg, #D4A017 0%, #FCD34D 100%)",

    "linear-gradient(180deg, #102A83 0%, #E11D48 100%)",

    "linear-gradient(180deg, #111827 0%, #374151 100%)",
  ],
});

export default theme;
